export enum OrganismeStatutType {
  ATTENTE_HABILITATION = 'ATTENTE_HABILITATION',
  CREATION = 'CREATION',
  MAJ_ANNUELLE = 'MAJ_ANNUELLE',
  VALIDE = 'VALIDE',
  DEMANDE_INFORMATION = 'DEMANDE_INFORMATION',
  REFUS = 'REFUS',
  MAJ_DOCUMENTS = 'MAJ_DOCUMENTS',
  ATTENTE_REVALIDATION_HABILITATION = 'ATTENTE_REVALIDATION_HABILITATION',
  DEVALIDE = 'DEVALIDE',
  DEPOT_BLOQUE = 'DEPOT_BLOQUE',
}

export const POST_VALIDES_STATUTS = [
  OrganismeStatutType.VALIDE,
  OrganismeStatutType.MAJ_DOCUMENTS,
  OrganismeStatutType.ATTENTE_REVALIDATION_HABILITATION,
  OrganismeStatutType.DEVALIDE,
  OrganismeStatutType.DEPOT_BLOQUE,
];

export const NON_WRITABLE_STATUTS: OrganismeStatutType [] = [
  OrganismeStatutType.ATTENTE_HABILITATION,
  OrganismeStatutType.CREATION,
  OrganismeStatutType.MAJ_ANNUELLE,
  OrganismeStatutType.REFUS,
  OrganismeStatutType.DEVALIDE,
  OrganismeStatutType.MAJ_DOCUMENTS,
  OrganismeStatutType.ATTENTE_REVALIDATION_HABILITATION,
];

export function isOrganismeStatutPostValide(statut: OrganismeStatutType) {
  return POST_VALIDES_STATUTS.includes(statut);
}

export const ORGANISME_VALIDES_STATUTS = [
  OrganismeStatutType.VALIDE,
  OrganismeStatutType.DEPOT_BLOQUE,
];